var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.916,
    cy: 6.7141,
    r: 6.27245,
    fill: "#1FA1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54326 4.20513C7.54326 3.85871 7.26243 3.57788 6.91601 3.57788C6.56959 3.57788 6.28876 3.85871 6.28876 4.20513L6.28876 6.08686H4.40703C4.06061 6.08686 3.77979 6.36769 3.77979 6.71411C3.77979 7.06052 4.06061 7.34135 4.40703 7.34135H6.28876L6.28876 9.22309C6.28876 9.5695 6.56959 9.85033 6.91601 9.85033C7.26243 9.85033 7.54325 9.5695 7.54325 9.22309L7.54325 7.34135H9.42499C9.77141 7.34135 10.0522 7.06052 10.0522 6.71411C10.0522 6.36769 9.77141 6.08686 9.42499 6.08686H7.54325L7.54326 4.20513Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/addButton.70322cbfc615956b4e22f14c8d1c8026.svg";
export { ForwardRef as ReactComponent };